import { useBooleanFlagValue } from '@openfeature/react-sdk'

import { useEnsureRemoteFeatureFlags } from './useEnsureRemoteFeatureFlags'

export const useRemoteFeatureFlag = (flagKey: string, defaultValue = false): boolean => {
  useEnsureRemoteFeatureFlags()
  return useBooleanFlagValue(flagKey, defaultValue)
}
